/**
 * Returns the current location without the query string.
 */
function locationWithoutQueryString() {
  return [window.location.protocol, '//', window.location.host, window.location.pathname].join('');
}

/**
 * Checks if the current window location has an authorization code as a query parameter.
 */
function hasAuthCode() {
  return new URL(window.location.href).searchParams.has('code');
}

export const url = {
  locationWithoutQueryString,
  hasAuthCode,
};
